import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';

import { api as apiAuth } from '#adapter/api/auth';
import { rtkApi } from '#adapter/api/campaigns/v5/suppliers';
import { qa } from '#adapter/qa';
import { get } from '#adapter/cookie';
import { env } from '#helper/env';

interface IState {
    isAuthenticated: boolean,
    accessToken?: string,
    employeeID?: number,
    sessionID?: string,
    userID?: number,
    supplierOldID?: number,
    supplierID?: string
}

const initialState: IState = {
    isAuthenticated: false
};

/* eslint-disable no-param-reassign */
export const slice = createSlice({
    initialState,
    name    : 'user',
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(rtkApi.endpoints.getApiV5Suppliers.matchFulfilled, (store, action) => {
                const supplierOldID = env(import.meta.env.APP_SUPPLIER_OLD_ID) || qa.getSupplierOldID();
                const supplierID = env(import.meta.env.APP_SUPPLIER_ID) || qa.getSupplierID();

                if(supplierOldID) {
                    store.supplierOldID = supplierOldID;
                }

                if(supplierID) {
                    store.supplierID = supplierID;
                }

                if(Array.isArray(action.payload?.result?.suppliers)) {
                    const currentSupplierId = get(import.meta.env.APP_COOKIE_NAME_SUPPLIER_EXTERNAL);

                    if(action.payload.result.suppliers) {
                        let result;

                        if(currentSupplierId) {
                            const findSupplier = action.payload.result.suppliers
                                .find((supplier) => supplier.id === currentSupplierId);

                            if(findSupplier) {
                                result = findSupplier;
                            }
                        }

                        if(result) {
                            if(!supplierID) {
                                store.supplierID = result.id;
                            }

                            if(!supplierOldID) {
                                store.supplierOldID = result.oldID;
                            }
                        }
                    }
                }
            })
            .addMatcher(apiAuth.endpoints.check.matchFulfilled, (store, action) => {
                store.isAuthenticated = true;
                store.sessionID = action.payload?.sessionID;
                store.userID = action.payload?.userID;
                store.employeeID = action.payload?.employeeID;

                if(action.payload?.accessToken) {
                    const jwt = jwtDecode<{
                        client_id: string,
                        iat: number,
                        phone: string,
                        session_id: string,
                        shard_key: string,
                        user: string,
                        user_registration_dt: number,
                        validation_key: string,
                        version: number
                    }>(action.payload.accessToken);

                    store.accessToken = action.payload.accessToken;
                    store.sessionID = jwt.session_id;
                    store.userID = parseInt(jwt.user, 10);
                }
            });
    }
});
